import type { CandidateVacancy } from '../types';

type CandidateRegion = NonNullable<
  CandidateVacancy['cities']
>[number]['region'];

export function mockCandidateRegion(
  overrides: Partial<CandidateRegion> = {}
): CandidateRegion {
  return {
    id: 1,
    name: 'Paris Region',
    ...overrides,
  };
}
